import classNames from "classnames";
import React from "react";
import { useLocation } from "react-router-dom";

import { getQueryParam, staticUrl } from "src/utils";

const OnboardingBreadcrumbs = () => {
  const location = useLocation();
  const assetUrl = staticUrl("images/backgrounds/onboarding.jpg");
  const { pathname } = location;
  const sso = getQueryParam("sso");
  const offset = sso ? 0 : 1;

  return (
    <div
      id="onboarding-breadcrumbs"
      className="bg-black-tint-20 full-height"
      style={{ backgroundImage: `url(${assetUrl})`, backgroundSize: "cover" }}
    >
      <div className="text-white p10 mb10 fixed bottom-0">
        <div className="h2">First Steps</div>
        <div className="body">
          <p>
            To finish creating your Forum profile, you&apos;ll need to complete the following steps:
          </p>
          {!sso ? (
            <p className={classNames({ bold: pathname.match(/\d+/g) })}>
              1. Create a unique password
            </p>
          ) : null}
          <p className={classNames({ bold: pathname.includes("accept-terms") })}>
            {offset + 1}. Agree to the Terms of Service
          </p>
          <p>{offset + 2}. Perform a system check</p>
          <p className={classNames({ bold: pathname.includes("photo") })}>
            {offset + 3}. Upload a profile photo
          </p>
        </div>
      </div>
    </div>
  );
};

export { OnboardingBreadcrumbs };
